export default __webpack_public_path__ + "static/media/foto11.342e34a8.jpg";